import React from "react";
import { Heading1, Paragraph } from "../shared/layout";
import { Button } from "../shared/utilities";
import { useNavigate } from "react-router-dom";
import ClaudeLogo from "../components/Brand/Logo";

const Error = () => {
  const navigate = useNavigate();
  const navHome = () => {
    navigate("/");
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        gap: "18px",
        marginTop: "10vh",
      }}
    >
      <ClaudeLogo size={40} />
      <Heading1>页面未找到</Heading1>
      <Paragraph style={{ textAlign: "center", maxWidth: "420px" }}>
        我们找不到你要访问的页面，让我们回到新的对话吧。
      </Paragraph>
      <div style={{ marginTop: "8px", width: "100%", maxWidth: "260px" }}>
        <Button onClick={navHome}>返回首页</Button>
      </div>
    </div>
  );
};

export default Error;
